var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelpNewHeightInside3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "303px",
    height: "453px",
    viewBox: "0 0 303 453",
    enableBackground: "new 0 0 303 453",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n\t\t\t@font-face {\r\n\t\t\tfont-family: \"proximanova-nova\";\r\n\r\n\t\t\tsrc: url('https://doopsalta2.com/Fonts/proxima-nova-three.woff2') format('woff2'),\r\n\t\t\t\turl('https://doopsalta2.com/Fonts/proxima-nova-three.woff') format('woff'),\r\n\t\t\t\turl('https://doopsalta2.com/Fonts/proxima-nova-three.otf') format('opentype');\r\n\t\t\tfont-style: normal;\r\n\t\t\t}\r\n\t\t"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 10.8,
    y: 55,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    width: 280.2,
    height: 389
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.8,
    y: 78.1,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    width: 234,
    height: 342.8
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 2.989,
    x1: 66,
    y1: 406.5,
    x2: 66,
    y2: 92
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "74.9,403.9 66,419.4 57.1,403.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "74.9,94.6 66,79.1 57.1,94.6  "
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 2.989,
    x1: 150.9,
    y1: 406.5,
    x2: 150.9,
    y2: 92
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "159.8,403.9 150.9,419.4 141.9,403.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "159.8,94.6 150.9,79.1 141.9,94.6  "
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 2.989,
    x1: 234.3,
    y1: 406.5,
    x2: 234.3,
    y2: 92
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "243.3,403.9 234.3,419.4 225.4,403.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "243.3,94.6 234.3,79.1 225.4,94.6  "
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M56.8,20.1L64.6,1h3l7.7,19.1h-2.7l-1.7-4.3h-9.6l-1.7,4.3H56.8z M61.9,13.7h8.1L66,3.4L61.9,13.7z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M144.3,20.1V1h8.5c1.7,0,3,0.5,3.9,1.3c1,1,1.4,2,1.4,3.6c0,1.2-0.4,2.2-1,2.9c-0.6,0.7-1.4,1.3-2.4,1.4 c1,0.1,1.9,0.7,2.6,1.7c0.7,1,1.1,1.9,1.1,3.1c0,1.6-0.5,2.9-1.4,3.7c-1,0.8-2.4,1.4-4.1,1.4H144.3z M146.7,9.2h5.7 c1.1,0,1.9-0.2,2.4-0.8c0.5-0.6,0.8-1.3,0.8-2.2s-0.2-1.7-0.8-2.3c-0.6-0.6-1.4-0.8-2.4-0.8h-5.7V9.2z M146.7,18h5.9 c1.1,0,1.9-0.2,2.6-0.8c0.7-0.6,1-1.4,1-2.4s-0.4-1.7-1-2.4c-0.6-0.6-1.4-1-2.6-1h-5.9V18z"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M226.5,15c-0.5-1.2-0.7-2.6-0.7-4.1s0.2-2.7,0.7-4.1c0.5-1.2,1.2-2.3,2-3.1c0.8-0.8,1.9-1.6,3.1-2 s2.5-0.7,3.8-0.7c3.1,0,5.5,1.3,7.3,3.8l-2,1.1c-0.6-0.8-1.3-1.6-2.3-2s-1.9-0.7-3-0.7c-2.2,0-3.8,0.7-5.3,2.2 c-1.4,1.4-2.2,3.3-2.2,5.6c0,1.4,0.4,2.9,1,4.1c0.6,1.2,1.6,2.2,2.6,2.7s2.4,1,3.7,1c1.1,0,2-0.2,3-0.7s1.7-1.2,2.3-2l2,1.1 c-1.9,2.5-4.3,3.8-7.3,3.8c-1.3,0-2.6-0.2-3.8-0.7s-2.3-1.2-3.1-2C227.7,17.4,227,16.3,226.5,15z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpNewHeightInside3);
export default __webpack_public_path__ + "static/media/help_new_height_inside_3.d13998ddc3ed6db627323fd604bc1500.svg";
export { ForwardRef as ReactComponent };